export const getProcessStatementResults = (state) => state.processStatement.processStatementDetailResults;